/* SEASON34 Formula Landing — proof animations + timeline reveal.
   Vanilla JS, defer-loaded, scoped to elements present only on this template. */
(function () {
  var root = document.querySelector('.template-page-formula-landing');
  if (!root) return;

  /* Build proof dial ticks */
  (function buildTicks() {
    var g = document.getElementById('fl-proof-ticks');
    if (!g) return;
    var cx = 250, cy = 230, rOuter = 175, rInner = 162;
    var TARGET = 90.7, ticks = 21;
    for (var i = 0; i < ticks; i++) {
      var pct = (i / (ticks - 1)) * 100;
      var angle = (-180 + (pct / 100) * 180) * Math.PI / 180;
      var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', (cx + Math.cos(angle) * rInner).toFixed(2));
      line.setAttribute('y1', (cy + Math.sin(angle) * rInner).toFixed(2));
      line.setAttribute('x2', (cx + Math.cos(angle) * rOuter).toFixed(2));
      line.setAttribute('y2', (cy + Math.sin(angle) * rOuter).toFixed(2));
      line.setAttribute('stroke-width', i % 2 === 0 ? 2.5 : 1.5);
      line.setAttribute('stroke-linecap', 'round');
      line.classList.add('fl-tick');
      if (pct <= TARGET) {
        line.classList.add('fl-lit');
        line.style.transitionDelay = (i * 80) + 'ms';
      }
      g.appendChild(line);
    }
  })();

  /* Build flush bars */
  (function buildFlushBars() {
    var g = document.getElementById('fl-proof-flush-bars');
    if (!g) return;
    var N = 28, x0 = 50, x1 = 470, yBase = 280;
    for (var i = 0; i < N; i++) {
      var t = i / (N - 1);
      var decay = Math.pow(1 - t, 1.6);
      var noise = (Math.sin(i * 1.7) * 0.06 + Math.cos(i * 2.3) * 0.04);
      var h = Math.max(4, (decay + noise) * 200);
      var x = x0 + t * (x1 - x0);
      var rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rect.setAttribute('x', x - 3);
      rect.setAttribute('y', yBase - h);
      rect.setAttribute('width', 6);
      rect.setAttribute('height', h);
      rect.setAttribute('rx', 3);
      rect.setAttribute('class', 'fl-bar');
      rect.style.transitionDelay = (i * 40) + 'ms';
      rect.setAttribute('fill-opacity', (0.95 - t * 0.65).toFixed(2));
      g.appendChild(rect);
    }
  })();

  function playDial() {
    var dial = document.getElementById('fl-proof-dial');
    if (!dial) return;
    dial.classList.remove('is-on');
    void dial.offsetWidth;
    dial.classList.add('is-on');
  }
  function playSymptoms() {
    var root2 = document.getElementById('fl-proof-symptoms');
    if (!root2) return;
    var treatedBar = root2.querySelector('.fl-bar-fill.fl-treated');
    var treatedNum = root2.querySelector('[data-score-treated]');
    if (!treatedBar || !treatedNum) return;
    root2.classList.remove('is-on');
    treatedBar.style.transition = '';
    treatedBar.style.height = '0%';
    treatedNum.textContent = '34';
    void root2.offsetWidth;
    root2.classList.add('is-on');
    setTimeout(function () {
      treatedBar.style.transition = 'height 1400ms cubic-bezier(0.22, 1, 0.36, 1)';
      treatedBar.style.height = '35.2%';
      var start = performance.now(), DUR = 1400;
      function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
      function tick(now) {
        var t = Math.min(1, (now - start) / DUR);
        var v = 34 - ease(t) * (34 - 13.6);
        treatedNum.textContent = v.toFixed(1).replace(/\.0$/, '');
        if (t < 1) requestAnimationFrame(tick);
        else treatedNum.textContent = '13.6';
      }
      requestAnimationFrame(tick);
    }, 1300);
  }
  function playFlush() {
    var root2 = document.getElementById('fl-proof-flush');
    if (!root2) return;
    root2.classList.remove('is-on');
    void root2.offsetWidth;
    root2.classList.add('is-on');
  }

  var PLAYERS = {
    'fl-proof-dial': playDial,
    'fl-proof-symptoms': playSymptoms,
    'fl-proof-flush': playFlush
  };
  var seen = {};
  function trigger(id) {
    if (seen[id]) return;
    seen[id] = true;
    var fn = PLAYERS[id];
    if (fn) fn();
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) trigger(e.target.id); });
    }, { threshold: 0.2 });
    Object.keys(PLAYERS).forEach(function (id) {
      var el2 = document.getElementById(id);
      if (el2) io.observe(el2);
    });
    var proofSection = document.getElementById('proof');
    if (proofSection) {
      var sectionIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) Object.keys(PLAYERS).forEach(trigger);
        });
      }, { threshold: 0.15 });
      sectionIO.observe(proofSection);
    }
  } else {
    Object.keys(PLAYERS).forEach(trigger);
  }

  /* Timeline reveal */
  var tlSteps = document.querySelectorAll('.fl-timeline-step');
  if (tlSteps.length && 'IntersectionObserver' in window) {
    var tlIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var idx = parseInt(e.target.dataset.idx || '0', 10);
          setTimeout(function () { e.target.classList.add('in-view'); }, idx * 120);
          tlIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    tlSteps.forEach(function (s, i) { s.dataset.idx = i; tlIO.observe(s); });
  }

  /* Smooth anchor scrolling for in-page nav */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href === '#' || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', href);
  });
})();
